import React from 'react';
import LiquidFillLoader from './LiquidFillLoader';

const BrandLoadingSpinner = ({ message = "Loading...", size = "medium" }) => {
  const sizeConfig = {
    small: 80,
    medium: 100,
    large: 120
  };

  const loaderSize = sizeConfig[size] || sizeConfig.medium;

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <LiquidFillLoader size={loaderSize} />
      
      {message && (
        <p 
          className="mt-4 text-sm font-medium"
          style={{ 
            color: '#1d0c46',
            fontFamily: 'Raleway, sans-serif'
          }}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default BrandLoadingSpinner;